import React from 'react';
import PollCommentsModal from './PollCommentsModal';

const Poll = ({ user, poll, setPolls, handleVote }) => {
    return (
        <div className='card card-compact min-w-[295px] max-w-[500px] w-[65%] lg:w-[30%] shadow-xl bg-white/60 backdrop-blur-lg'>
            <div className='w-full h-[277px] rounded-t-box overflow-hidden'>
                {poll.options.length > 1 &&
                poll.options.every(
                    (option) => option.image && option.image.trim() !== ''
                ) ? (
                    <div className='w-full h-full flex gap-1'>
                        {poll.options.map((option) => (
                            <label
                                key={`image-${poll.id}-${option.id}`}
                                title={`Click to select ${option.text}`}
                                className={`w-full h-full bg-cover bg-center rounded-none cursor-pointer transition-all duration-200 ease-out ${
                                    option.voted ? '!opacity-100' : 'opacity-80'
                                } hover:opacity-85`}
                                style={{
                                    backgroundImage: `url(${option.image})`,
                                }}
                                onClick={() => handleVote(poll.id, option.id)}>
                                <input
                                    name={`radio-${poll.id}`}
                                    type='radio'
                                    className='hidden'
                                />
                            </label>
                        ))}
                    </div>
                ) : (
                    <figure
                        className='w-full h-full bg-cover bg-center'
                        style={{
                            backgroundImage: `url(${poll.image})`,
                        }}></figure>
                )}
            </div>
            <div className='card-body'>
                <h2 className='card-title'>{poll.question}</h2>
            </div>
            <div className='card-body !p-0 gap-0 justify-end'>
                <div className='flex flex-col p-4 gap-2'>
                    {poll.options.map((option) => {
                        const totalVotes = poll.options.reduce(
                            (voteCount, option) =>
                                voteCount + Number(option.votes.length),
                            0
                        );

                        let percentageWidth = 0;

                        if (poll.showResults) {
                            percentageWidth =
                                totalVotes > 0
                                    ? Math.round(
                                          (Number(option.votes.length) /
                                              totalVotes) *
                                              100
                                      )
                                    : 0;
                        }

                        return (
                            <div key={`option-${poll.id}-${option.id}`}>
                                <div
                                    className={`relative rounded-box border-2 border-[#3333] ${
                                        poll.showResults && 'border-[#58b4ff]'
                                    } flex items-center justify-between overflow-hidden`}>
                                    <div
                                        className={`absolute inset-0 bg-[#58b4ff] transition-all duration-500 ease-out`}
                                        style={{
                                            width: `${percentageWidth}%`,
                                        }}
                                    />
                                    <label className='flex items-center gap-2 cursor-pointer p-3 flex-1 z-10'>
                                        <label className='relative flex justify-center items-center cursor-pointer'>
                                            <input
                                                name={`radio-${poll.id}`}
                                                type='radio'
                                                className='peer h-5 w-5 cursor-pointer appearance-none rounded-full border border-[#3333] checked:border-[#3333] transition-all'
                                                checked={!!option.voted}
                                                onChange={() =>
                                                    handleVote(
                                                        poll.id,
                                                        option.id
                                                    )
                                                }
                                            />
                                            <span className='absolute bg-[#005aa3] w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'></span>
                                        </label>
                                        <span className='font-bold select-none'>
                                            {option.text}
                                        </span>
                                    </label>
                                    <div
                                        className='flex items-center p-3 cursor-pointer z-10'
                                        onClick={() =>
                                            document
                                                .getElementById(
                                                    `poll-card-modal-${poll.id}-${option.id}`
                                                )
                                                .showModal()
                                        }
                                        title='View votes'>
                                        {poll.showResults && (
                                            <span className='font-bold select-none'>
                                                {poll.options.length > 1
                                                    ? `${Math.round(
                                                          percentageWidth
                                                      )}%`
                                                    : option.votes.length}
                                            </span>
                                        )}

                                        <svg
                                            width={20}
                                            height={20}
                                            fill='none'
                                            stroke='currentColor'
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            strokeWidth={2.5}
                                            viewBox='0 0 24 24'
                                            xmlns='http://www.w3.org/2000/svg'>
                                            <path d='m9 18 6-6-6-6' />
                                        </svg>
                                    </div>
                                </div>
                                <dialog
                                    id={`poll-card-modal-${`${poll.id}-${option.id}`}`}
                                    className='modal overflow-auto p-10'>
                                    <div className='card card-compact max-w-[400px] w-full shadow-xl bg-white/80 backdrop-blur-lg text-[#333]'>
                                        <form method='dialog'>
                                            <button className='btn btn-sm btn-circle btn-ghost absolute right-2 top-2'>
                                                ✕
                                            </button>
                                        </form>
                                        <div className='card-body'>
                                            <h2 className='card-title justify-center'>
                                                {option.text}
                                            </h2>
                                            <div className='divider m-0'></div>
                                            {option.votes.map((user) => {
                                                return (
                                                    <div
                                                        key={`${poll.id}-${option.id}-${user.id}`}
                                                        className='flex gap-2 items-center'>
                                                        <div className='avatar w-10 h-10'>
                                                            <div className='w-full rounded-full'>
                                                                <img
                                                                    src={
                                                                        user.image
                                                                    }
                                                                    className='w-full'
                                                                    alt='user'
                                                                    loading='lazy'
                                                                />
                                                            </div>
                                                        </div>
                                                        <span className='font-bold'>
                                                            {user.name}
                                                        </span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </dialog>
                            </div>
                        );
                    })}
                </div>
                <div className='card-actions flex justify-end items-end px-4'>
                    {poll.comments.length > 0 && (
                        <span
                            className='opacity-80 hover:underline cursor-pointer'
                            onClick={() =>
                                document
                                    .getElementById(`card-${poll.id}-modal`)
                                    .showModal()
                            }
                            title='View or write a comment'>
                            {poll.comments.length}{' '}
                            {poll.comments.length === 1
                                ? 'comment'
                                : 'comments'}
                        </span>
                    )}
                </div>
                <div className='divider m-0'></div>
                <div className='flex gap-2 rounded-b-box overflow-hidden'>
                    <div
                        className='flex-1 flex justify-center font-bold p-4 cursor-pointer hover:bg-white/40 transition-all duration-200 ease-out'
                        onClick={() =>
                            document
                                .getElementById(`card-${poll.id}-modal`)
                                .showModal()
                        }
                        title='View or write a comment'>
                        Comment
                    </div>
                </div>
            </div>
            <PollCommentsModal user={user} poll={poll} setPolls={setPolls} />
        </div>
    );
};

export default Poll;
